import { z } from "zod";

import { imageFormatSchema } from "api/schemas/imageCollectionApiSchema";
import { signalSchema } from "api/schemas/signalsApiSchema";
import { topicSchema } from "api/schemas/topicsApiSchema";
import { nullToUndefined } from "api/utils";
import { ContentType, KnowledgeStatus } from "entities/knowledge/types";

const attachmentTypeSchema = z.enum(["video", "podcast", "audio", "pdf"]);

const attachmentSchema = z.object({
  id: z.string(),
  image_url: z.string().optional(),
  type: attachmentTypeSchema,
  url: z.string(),
});

const contentTypeSchema = z.nativeEnum(ContentType);

const embeddedMediaSchema = z.object({
  height: z.number().optional(),
  html: nullToUndefined(z.string()),
  title: nullToUndefined(z.string()),
  width: z.number().optional(),
  url: z.string().optional(),
});

export const sourceSchema = z.object({
  content_type: nullToUndefined(contentTypeSchema),
  id: nullToUndefined(z.string()),
  images: nullToUndefined(imageFormatSchema),
  name: z.string(),
});

export const knowledgeTypeSchema = z.union([z.literal("video"), z.literal("audio"), z.literal("article")]);

export const knowledgeStatusSchema = z.nativeEnum(KnowledgeStatus);

export const knowledgeSchema = z.object({
  attachment: nullToUndefined(attachmentSchema),
  authors: z.array(z.string()).default([]).optional(),
  created_at: z.string().nullish(),
  embedded_media: nullToUndefined(embeddedMediaSchema),
  language: nullToUndefined(z.string()),
  link: z.string(),
  id: z.string(),
  image: z.string().optional(),
  images: nullToUndefined(imageFormatSchema),
  interactive_link: nullToUndefined(z.string()),
  is_bookmarked: z.boolean().optional(),
  is_pinned: nullToUndefined(z.boolean()),
  publisher: z.string(),
  signals: z.array(signalSchema).optional(),
  source: sourceSchema,
  status: nullToUndefined(knowledgeStatusSchema),
  summary: nullToUndefined(z.string()),
  time: z.number(),
  time_bookmarked: z.number().optional(),
  title: z.string(),
  topics: nullToUndefined(z.array(topicSchema)),
  type: knowledgeTypeSchema,
});
